import "react";
import { ColorCircle } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/calendar/ServicePeriodCalendarLegend.tsx
var ITEMS = [
	{
		label: "Fulfilled",
		variant: "positive"
	},
	{
		label: "Partial",
		variant: "caution"
	},
	{
		label: "Missed",
		variant: "critical"
	},
	{
		label: "Active",
		variant: "main"
	}
];
function ServicePeriodCalendarLegend() {
	return /* @__PURE__ */ jsx("div", {
		className: "gap-sm flex flex-wrap items-center",
		children: ITEMS.map((item) => /* @__PURE__ */ jsxs("div", {
			className: "gap-xxs flex items-center",
			children: [/* @__PURE__ */ jsx(ColorCircle, {
				size: "sm",
				variant: item.variant
			}), /* @__PURE__ */ jsx("span", {
				className: "text-color-subtle text-sm",
				children: item.label
			})]
		}, item.variant))
	});
}
//#endregion
export { ServicePeriodCalendarLegend };

//# sourceMappingURL=ServicePeriodCalendarLegend.js.map